import { call, takeLatest, all, put, select } from 'redux-saga/effects';
import api from 'services/api';
import { Types, Creators } from 'store/ducks/module';
import { callApi } from 'store/sagas/auth';

function* getModule({ payload }) {
  try {
    const { id } = payload;
    const request = call(api.get, `/v1/admin/modules/${id}`);
    const response = yield call(callApi, request);

    if (response.status != 200 && response.status != 201) throw response;
    yield put(Creators.getModuleSuccess(response.data));
  } catch (err) {
    yield put(Creators.getModuleFailure('Erro ao buscar na API'));
  }
}
function* getGroups() {
  try {
    const request = call(api.get, `/v1/admin/children/groups`);
    const response = yield call(callApi, request);

    if (response.status != 200 && response.status != 201) throw response;
    yield put(Creators.getGroupsSuccess(response.data));
  } catch (err) {
    yield put(Creators.getModuleFailure('Erro ao buscar na API'));
  }
}

export default function* moduleSaga() {
  yield all([
    takeLatest(Types.GET_REQUEST, getModule),
    takeLatest(Types.GET_GROUPS_REQUEST, getGroups),
  ]);
}
